import { useState } from "react";

import { Button } from "components/ui/Button";
import { Dialog } from "components/ui/Dialog";
import { AddTaskForm } from "features/comunications/components/AddTaskForm/AddTaskForm";

export const AddTaskModal = ({
  patient,
  isDisabled,
  buttonClassName,
  task,
  modalTitle,
  buttonText,
  buttonEndIcon,
  buttonVariant,
  staffMemberId,
  initialAssigneeComments,
  initialTaskDescription,
  noButton,
  isOpen,
  setIsOpen,
  noDefaultAssignee,
}) => {
  let [isModalOpen, setIsModalOpen] = useState(false);

  if (isOpen) {
    isModalOpen = isOpen;
    setIsModalOpen = setIsOpen;
  }

  return (
    <>
      {!noButton && (
        <Button
          variant={buttonVariant || "text"}
          className={buttonClassName}
          type="button"
          disabled={isDisabled}
          endIcon={buttonEndIcon}
          onClick={() => setIsModalOpen(true)}
        >
          {buttonText || "Add new"}
        </Button>
      )}
      <Dialog
        open={isModalOpen}
        title={modalTitle || "Add Task"}
        onClose={() => setIsModalOpen(false)}
        width={800}
      >
        <AddTaskForm
          task={task}
          patient={patient}
          staffMemberId={staffMemberId}
          initialAssigneeComments={initialAssigneeComments}
          initialTaskDescription={initialTaskDescription}
          noDefaultAssignee={noDefaultAssignee}
          closeModal={() => setIsModalOpen(false)}
        />
      </Dialog>
    </>
  );
};
